import React, { Component } from 'react';
import './styles.scss';
import { Button } from 'reactstrap';
import { isObject, pluck, findWhere, isUndefined } from 'underscore'

export default class AttributeSelector extends Component {
  sorting = isUndefined(this.props.sorting) ? true : this.props.sorting;
  state = {
    items: this.sorting ? this.props.items.sort() : this.props.items,
    currentItem: ''
  };

  constructor(props) {
    super(props);

    if (isObject(this.props.items[0])) {
      this.state.items = this.sorting ? pluck(this.props.items, 'title').sort() : pluck(this.props.items, 'title');
    }
  }

  selectItem(currentItem) {
    this.props.onSelect(currentItem);
    this.setState({ currentItem });
  }

  isDisabled(item) {
    const originalItem = findWhere(this.props.items, { title: item });

    return originalItem && originalItem.disabled;
  }

  render() {
    return (
      <>
        {this.state.items.map(item =>
          <>
            <Button size="sm"
                    onClick={() => this.selectItem(item)}
                    outline
                    disabled={this.isDisabled(item)}
                    active={this.state.currentItem === item}>{item}</Button>{' '}
          </>
        )}
      </>
    );
  }
}
